module.exports = __webpack_public_path__ + "img/grass.ebdca925.png";